
import styled from 'styled-components';
import { Button } from 'carbon-components-react';

import MyModal from './Modal';

const ConfirmModal = ({
  title = "Confirmation",
  content = "Are you sure?",
  confirmButtonText = "Yes",
  open = false,
  onClose = () => {},
  onConfirm = () => {},
}) => {

  const btnStyle = {
    padding: "11px 18px",
    height: "auto",
    minHeight: "unset",
    width: "fit-content",
    borderRadius: "10px",
    fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
    fontWeight: 700,
    fontSize: "13.5px",
  };

  return (
    <MyModal
      modalHeading={title}
      size="sm"
      open={open}
      onRequestClose={onClose}
    >
      <ConfirmModalContent>
        <ConfirmText style={{ marginBottom: "18px" }}>{content}</ConfirmText>

        <ActionBar>
          <Button
            kind="secondary"
            onClick={onClose}
            style={{ ...btnStyle, marginRight: "15px" }}  
          >Cancel</Button>

          <Button
            kind="danger"
            onClick={() => onConfirm()}
            style={btnStyle}
          >{confirmButtonText}</Button>
        </ActionBar>
      </ConfirmModalContent>
    </MyModal>
  );
};

export default ConfirmModal;

const ConfirmModalContent = styled.div`
  display: flex;
  flex-direction: column;
`

const ConfirmText = styled.div`
  font-family: 'Plus Jakarta Sans', system-ui, sans-serif;
  font-size: 14px;
  color: #4a5563;
  line-height: 1.5;
`

const ActionBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  .bx--btn {
    font-weight: bold;
  }
`
